exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.foldoutToggle[data-v-87b499f2]{font-size:16px;padding:6px 8px;border-bottom:2px solid #000\n}\n.collapsed>.when-opened[data-v-87b499f2],:not(.collapsed)>.when-closed[data-v-87b499f2]{display:none\n}\n.foldout[data-v-87b499f2]{padding:10px 8px 5px 8px\n}\n.foldout[data-v-87b499f2] h3{display:none\n}\n.foldout[data-v-87b499f2] div{padding:2px 0\n}", ""]);

// exports
